export default "__VITE_ASSET__efbc4172__"